import React from "react";
import { parseListDate } from "helpers/parseListDate";
import { isPrintVisible, shouldShowHeaderContent } from "../GatewaySummary.utils";
import { GatewayHeaderProps } from "../GatewaySummary.types";

/**
 * GatewayHeader component displays the gateway title, description, and optional header dates
 * Renders in the header section of the gateway summary
 */
export const GatewayHeader: React.FC<GatewayHeaderProps> = ({
  gateway,
  expand,
  onExpand,
  headerGateway,
  tab,
  onPrint,
}) => {
  return (
    <div className="GatewayTitleContainer">
      {/* Gateway Title */}
      <h4>{gateway.gatewayName}</h4>

      {/* Print Button */}
      {isPrintVisible(gateway) && (
        <button
          className="BtnPrint"
          onClick={(e) => {
            e.stopPropagation();
            onPrint();
          }}
        ></button>
      )}

      {/* Gateway Description */}
      <div
        className={`RightSection ${
          headerGateway && gateway.description ? "HeaderGatewayPadding" : ""
        } ${!gateway.description ? "NoDescription" : ""}`}
      >
        <div className="TextContainer">{gateway.description && <p>{gateway.description}</p>}</div>
      </div>

      {/* Gateway header fields for Overview tab */}
      {shouldShowHeaderContent(tab, headerGateway, gateway) && headerGateway && (
        <div className="HeaderGatewayContainer">
          <div className="Dates">
            <div className="Date">
              {headerGateway.bPlannedActive && (
                <>
                  <div className="Label">Planned:</div>
                  <div className="Text">
                    {headerGateway.plannedDate
                      ? parseListDate(headerGateway.plannedDate, false)
                      : "-"}
                  </div>
                </>
              )}
            </div>
            <div className="Date">
              {headerGateway.bForecastActive && (
                <>
                  <div className="Label">Forecast:</div>
                  <div className="Text">
                    {headerGateway.forecastDate
                      ? parseListDate(headerGateway.forecastDate, false)
                      : "-"}
                  </div>
                </>
              )}
            </div>
            <div className="Date">
              {headerGateway.bActualActive && (
                <>
                  <div className="Label">Actual:</div>
                  <div className="Text">
                    {headerGateway.actualDate
                      ? parseListDate(headerGateway.actualDate, false)
                      : "-"}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
